// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayerSpeed__menu-c69f03 {
  min-width: 240px;
}

.VideoPlayerSpeed__menu-item-ae0d63 span:only-child {
  margin-inline-start: 40px;
}

.VideoPlayerSpeed__action-button-a25b0d {
  color: var(--addition-50);
}

.VideoPlayerSpeed__action-button-a25b0d:focus-visible {
  color: var(--ib-color-hover); /* TODO: change design */
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayerSpeed/VideoPlayerSpeed.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,4BAAA,EAAA,wBAAA;AACF","sourcesContent":[".menu {\n  min-width: 240px;\n}\n\n.menu-item span:only-child {\n  margin-inline-start: 40px;\n}\n\n.action-button {\n  color: var(--addition-50);\n}\n\n.action-button:focus-visible {\n  color: var(--ib-color-hover); /* TODO: change design */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `VideoPlayerSpeed__menu-c69f03`,
	"menu-item": `VideoPlayerSpeed__menu-item-ae0d63`,
	"menuItem": `VideoPlayerSpeed__menu-item-ae0d63`,
	"action-button": `VideoPlayerSpeed__action-button-a25b0d`,
	"actionButton": `VideoPlayerSpeed__action-button-a25b0d`
};
module.exports = ___CSS_LOADER_EXPORT___;
